<template>
<div>
    <div v-if="loader" class="flex justify-center items-center h-[100vh] w-[100vw]">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
    <div v-else>

    
    <switch-languages></switch-languages>

    <div class="flex justify-center items-center min-h-[100vh] w-[100vw] py-[6rem] bg-[#F2F5F7]">
        <div class="flex flex-col max-w-[85vw] w-[750px]">
            <div class="flex flex-col items-center max-w-[750px] mx-auto mb-3">
                <div>
                <img class="mb-3 rounded-lg w-[85px] h-[85px]" src="@/assets/img/intestations/agency-transparent.png"/>
                </div>          
            </div>
            <the-card >

                <div style="overflow: hidden">
                <transition :name="'traXR'" mode="out-in">
                    <router-view></router-view>
                </transition>




                </div>

            </the-card>

        </div>
    </div>

    <div>

        
        </div>

    </div>
</div>
</template>



<script>

import SwitchLanguages from '@/components/SwitchLanguages.vue';


export default {
   name: 'AccessPage',
   components: {
      SwitchLanguages
   },
   data() {
      return {
        

        recaptchaResponse: null,

        disable_rules: true,

        email: "",
        password: "",
        formIsValid: true,
        isLoading: false,

        pricacy: false,
        pricacy_2: false,
        newsletter: false,

        error_email: false,
        error_phone: false,

        menu1: false,
        validation_phone: {},
        valid_associate_create: true,
        valid_associate_login: true,
        valid_reset_pass: true,
        

        tab: 'login',
        transitionName: 'traXR',

        loader: true,

        email_for_reset: "",

        autoEmail: "",
        autoPassword: "",

      };
   },
   watch: {
      tab() {
         this.disable_rules = true 
         this.email_for_reset = "" 
      },
      email_for_reset() {
         this.disable_rules = true 
      },
   },
   
   methods: {
        async recaptcha() {
            // (optional) Wait until recaptcha has been loaded.
            await this.$recaptchaLoaded()

            // Execute reCAPTCHA with action "login".
            const token = await this.$recaptcha('login')
            console.log("token",token);

            // Do stuff with the received token.
        },
   },
   async created () {
      setTimeout(() => this.loader = false, 1000);
   },
    
};
</script>

<style lang="scss" scoped>

ul li p {
   margin-bottom: 23px !important;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}

.login {
   &--page {
      background-size: cover;
      background-position: bottom;
      position: relative;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;

      &:after {
         @include AfterFullContainer();
         z-index: 1;
         background: rgba($black, 0.3);
      }
   }

   &--wrapper {
      position: relative;
      z-index: 4;
      max-width: 1200px;
      width: 100%;
   }

   &--row {
      justify-content: center;
      max-width: calc(100vw + 24px);
   }

   &--col {
     display: flex;
      justify-content: center;
      align-items: center;
      &__login {
         justify-content: flex-end;
      }
      &__news {
         justify-content: flex-start;
         align-items: flex-start;
         display: flex;
         flex-direction: column;
      }
      @media screen and (max-width: 1200px) {
         justify-content: center;
         align-items: center;
      }
   }

   &--news {
      position: relative;

      width: 500px;
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      padding: 2rem;
      color: $black !important;

      border-radius: 6px;
      background: rgba(255, 255, 255, 0.65);

      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(11px);

      @include box-shadow();

      &:not(:first-child) {
         margin-top: 1rem;
      }

      .v-icon {
         position: absolute;
         top: 5px;
         right: 5px;
         opacity: 0.5;
         transition: opacity 0.3s ease;
         &:hover {
            opacity: 1;
         }
      }
   }

   &--card {
      position: relative;
      height: fit-content;
      width: 500px;
      max-width: 90vw;
      display: flex;
      flex-direction: column;
      padding: 3.5rem;
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.65);

      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
      backdrop-filter: blur(11px);

      @include box-shadow();
   }

   &--img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      align-items: center;
      justify-content: center;

      overflow: hidden;
      border-radius: 100px;
      height: 75px;
      width: 75px;
      background: white;
      @include box-shadow();
      img {
         height: 80%;
         width: 80%;
      }
   }
}
.v-progress-linear {
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
}
</style>